module.exports = __webpack_public_path__ + "img/non-returnable.7225028.svg";